import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import RewardsComp from "../../../Components/RewardsComp";
import Choose from "../../../Components/Choose";
import UserReviews from "../../../Components/UserReviews";
import TrustedComp from "../../../Components/TrustedComp";
import GetInTouch from "../../../Components/GetInTouch";
import Img from "../../../assets/images/image";
import GAlign from "../../../Components/GAlign";
import { Helmet } from "react-helmet";
import Animation from "../../../animations/Animation";
import HeroSection from "../../../Components/HeroSection/HeroSection";
import DigitalSolutions2 from "./partials/DigitalSolutions2";

export default function ProjectDevelopment() {
   return (
      <div className="animation fadeIn">
         <Helmet>
            <title>Project Development</title>
            <meta
               name="description"
               content="Empowering businesses with cutting-edge software solutions. From seamless web apps to enterprise apps, we drive your success in the digital age. Explore now!"
            />
            <link rel="canonical" href="https://www.witmates.com/project_development" />
         </Helmet>
         <div>
            <HeroSection
               image={Img.servicesBanner}
               heading={
                  <>
                     <span className="witmates-theme-color">Deliver</span> Top- <span className="witmates-theme-color">notch</span> <br /> Project Development <br />
                     <span className="witmates-theme-color">Services</span>
                  </>
               }
               description={
                  <>
                     We offer a wide array of cutting-edge project development solutions to empower your business. From mobile apps and web development to enterprise applications, design development
                     and QA testing, we have the expertise and experience to drive your business forward in this digital age.
                  </>
               }
               link
            />
            <section className="section-gap industryList careers bgBlack">
               <Container>
                  <Row>
                     <Col>
                        <Animation fade bottom>
                           <GAlign align="center" direction="column">
                              <h2 className="fBold tabHeadingFontSize mobSubTitle colorWhite">
                                 Comprehensive Digital <br />
                                 Solutions for <span className="colorOrange fBold">Your Business</span>
                              </h2>
                           </GAlign>
                        </Animation>
                     </Col>
                  </Row>
                  <DigitalSolutions2 />
               </Container>
            </section>
            <Choose />
            <div className="pb100 mobPb20">
               <RewardsComp />
            </div>
            <UserReviews />
            <GetInTouch />
            <div className="pb100">
               <TrustedComp />
            </div>
         </div>
      </div>
   );
}
